/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Ad_Duration_Warning_TitleInputs */

const en_event_ad_duration_warning_title = /** @type {(inputs: Event_Ad_Duration_Warning_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We believe the number of words exceeds the duration of the event. Try trimming the event to fix this error.`)
};

const fr_event_ad_duration_warning_title = /** @type {(inputs: Event_Ad_Duration_Warning_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous pensons que le nombre de mots depasse la duree de l'evenement. Essayez de raccourcir l'evenement pour corriger cette erreur.`)
};

const de_event_ad_duration_warning_title = /** @type {(inputs: Event_Ad_Duration_Warning_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wir gehen davon aus, dass die Wortanzahl die Dauer des Ereignisses überschreitet. Bitte kürzen Sie das Ereignis, um diesen Fehler zu beheben.`)
};

const it_event_ad_duration_warning_title = /** @type {(inputs: Event_Ad_Duration_Warning_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riteniamo che il numero di parole superi la durata dell'evento. Prova a tagliare l'evento per correggere questo errore.`)
};

const ru_event_ad_duration_warning_title = /** @type {(inputs: Event_Ad_Duration_Warning_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мы считаем, что количество слов превышает продолжительность события. Попробуйте сократить событие, чтобы исправить эту ошибку.`)
};

const es_event_ad_duration_warning_title = /** @type {(inputs: Event_Ad_Duration_Warning_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creemos que la cantidad de palabras excede la duración del evento. Intente acortar el evento para corregir este error.`)
};

const zh_cn2_event_ad_duration_warning_title = /** @type {(inputs: Event_Ad_Duration_Warning_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们认为字数超过了事件持续时间。请尝试缩短事件长度以解决此错误。`)
};

const ja_event_ad_duration_warning_title = /** @type {(inputs: Event_Ad_Duration_Warning_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単語数がイベントの所要時間を超えていると思われます。イベントを短縮してこのエラーを修正してみてください。`)
};

const hi_event_ad_duration_warning_title = /** @type {(inputs: Event_Ad_Duration_Warning_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हमें लगता है कि शब्दों की संख्या इवेंट की अवधि से अधिक है। इस त्रुटि को ठीक करने के लिए इवेंट को छोटा करने का प्रयास करें।`)
};

const pt_pt2_event_ad_duration_warning_title = /** @type {(inputs: Event_Ad_Duration_Warning_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acreditamos que o número de palavras excede a duração do evento. Tente reduzir o número de palavras no evento para corrigir esse erro.`)
};

/**
* | output |
* | --- |
* | "We believe the number of words exceeds the duration of the event. Try trimming the event to fix this error." |
*
* @param {Event_Ad_Duration_Warning_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_duration_warning_title = /** @type {((inputs?: Event_Ad_Duration_Warning_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Duration_Warning_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_ad_duration_warning_title(inputs)
	if (locale === "de") return de_event_ad_duration_warning_title(inputs)
	if (locale === "it") return it_event_ad_duration_warning_title(inputs)
	if (locale === "ru") return ru_event_ad_duration_warning_title(inputs)
	if (locale === "es") return es_event_ad_duration_warning_title(inputs)
	if (locale === "zh-CN") return zh_cn2_event_ad_duration_warning_title(inputs)
	if (locale === "ja") return ja_event_ad_duration_warning_title(inputs)
	if (locale === "hi") return hi_event_ad_duration_warning_title(inputs)
	if (locale === "pt-PT") return pt_pt2_event_ad_duration_warning_title(inputs)
	return en_event_ad_duration_warning_title(inputs)
});